import { render, staticRenderFns } from "./menu-bf.vue?vue&type=template&id=9ad6a8da"
import script from "./menu-bf.vue?vue&type=script&lang=js"
export * from "./menu-bf.vue?vue&type=script&lang=js"
import style0 from "./menu-bf.vue?vue&type=style&index=0&id=9ad6a8da&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports